import React from "react";

import Icons from "../icons";
import { ICONS } from "../../constants/icons.constants";
import { AbsoluteWrapper } from "../../kaya";
import ScheduleToPlaySongPopUp from "../scheduleToPlaySongPopUp";
import userStore from "../../zustand/user.store";

const ScheduleIconComponent = ({ row }) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <AbsoluteWrapper
        componentToTrigger={
          <div>
            <Icons type={ICONS.MY_SCHEDULE} />
          </div>
        }
      >
        {/* {isVisible && ( */}
        <ScheduleToPlaySongPopUp
          playlistId={row.id || ""}
          setIsVisible={setIsVisible}
        />
        {/* )} */}
      </AbsoluteWrapper>
    </div>
  );
};

export default ScheduleIconComponent;
